import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Navigate } from 'react-router-dom';
import Recorder from './Recorder';
import { useCurrentPlanFeatures } from '@/hooks/useCurrentPlanFeatures';
import { useAuthStore } from '@/stores/authStore';
import { AccountStatusTypes } from '@/helpers/accountStatus';
import { RouteMap } from '@/routes/Routes';
import React from 'react';

const VideoRecordPage: React.FC = () => {
  const { accountStatus } = useAuthStore();
  const planFeatures = useCurrentPlanFeatures();
  const planLimitSeconds = planFeatures.video_seconds ?? 120;
  const planQualityNumber = planFeatures.videoQualityNumber ?? 720;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (accountStatus === AccountStatusTypes.EXPIRED) {
    return <Navigate to={RouteMap.PLAN} replace />;
  }

  return (
    <Box
      px={{ xs: '12px', sm: '32px' }}
      py={isMobile ? '8px' : '24px'}
      sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '900px', mx: 'auto' }}
    >
      {!isMobile && (
        <>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
            Record Video
          </Typography>
        </>
      )}

      <Recorder maxDuration={planLimitSeconds} maxResolution={planQualityNumber} planLimit={planLimitSeconds} />
    </Box>
  );
};

export default VideoRecordPage;
